export default __webpack_public_path__ + "a8b4f84cd2553a0aea289f35fe904d71.png";